import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Container, Link, Typography } from '@mui/material';

export default function PublicHiringFooter() {
  return (
    <Box sx={{ mt: 6, borderTop: 1, borderColor: 'divider', bgcolor: '#fafafa', py: 3 }}>
      <Container maxWidth="lg" sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, justifyContent: 'space-between' }}>
        <Typography variant="body2" color="text.secondary">
          © {new Date().getFullYear()} JobMockAI
        </Typography>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
          <Link component={RouterLink} to="/privacy" underline="hover" variant="body2">
            Privacy
          </Link>
          <Link component={RouterLink} to="/terms" underline="hover" variant="body2">
            Terms
          </Link>
          <Link component={RouterLink} to="/hiring" underline="hover" variant="body2">
            For employers
          </Link>
          <Link component={RouterLink} to="/interview/practice" underline="hover" variant="body2">
            AI interview practice
          </Link>
        </Box>
      </Container>
    </Box>
  );
}

